/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-namespace */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-use-before-define */
/* eslint-disable react-perf/jsx-no-new-object-as-prop */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import React from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import { CloseIcon, IcoMoon } from '../../../index'
import {
  StyledDialogCloseButton,
  StyledDialogContent,
  StyledDialogOverlay,
  StyledDialogDeleteAccountContent,
  StyledDialogHeader,
  StyledH3,
} from './Modal.css'

interface IModalProps {
  open: boolean
  // eslint-disable-next-line no-unused-vars
  onOpenChange: (open: boolean) => void;
  content: React.ReactElement;
  'data-testid'?: string
  isDeleteAccountModal?: boolean
  header?: React.ReactNode | string
  desktopWidth?: string
  mobileMaxWidth?: string
  espp?: boolean
  isCloseButtonDisplay?:boolean,
  style?: React.CSSProperties
}

const Modal: React.FC<IModalProps> = ({
  open,
  onOpenChange,
  content,
  'data-testid':
  dataTestid,
  isDeleteAccountModal,
  header = null,
  desktopWidth,
  mobileMaxWidth,
  espp = false,
  isCloseButtonDisplay = true,
  style = {},
}) => (
  <Dialog.Root modal open={open} onOpenChange={onOpenChange}>
    <Dialog.Portal>
      <StyledDialogOverlay />
      {isDeleteAccountModal
        ? (
          <StyledDialogDeleteAccountContent>
            {content}
          </StyledDialogDeleteAccountContent>
        )
        : (
          <StyledDialogContent
            data-testid={dataTestid}
            desktopWidth={desktopWidth}
            mobileMaxWidth={mobileMaxWidth}
            style={espp ? { width: '616px', ...style } : style}
          >
            <StyledDialogHeader>
              <div>
                {Boolean(header) && typeof header === 'string' ? <StyledH3>{header}</StyledH3> : header}
              </div>
              {isCloseButtonDisplay && (
                <div>
                  <StyledDialogCloseButton data-testid="modal-close">
                    <IcoMoon
                      icon={CloseIcon}
                      color="#3E3E47"
                      size="19px"
                      viewBoxProp="7 7 19 19"
                    />
                  </StyledDialogCloseButton>
                </div>
              )}
            </StyledDialogHeader>
            {content}
          </StyledDialogContent>
        )}
    </Dialog.Portal>
  </Dialog.Root>
)

export default Modal
